/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import toastr from 'toastr';
import axios from 'axios-es6';
import $ from 'jquery';
import Swal from 'sweetalert2';
import Database from '../../Logic/Database';
import CurrentLocationModal from '../Fitment/CurrentLocationModal';
import FitmentOptions from '../FitmentOptions';
import FitmentLogic from '../../Logic/Fitment';
import ClaimLogic from '../../Logic/Claim';
import VehicleLogic from '../../Logic/Vehicle';
import global from '../../global';
import TakePhotoButton from '../Vehicle/TakePhotoButton/TakePhotoButton';
import 'react-accessible-accordion/dist/fancy-example.css';
import './AdditionalInfo.css';

class AdditionalInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        CustAppId: window.location.search.substr(1),
        VehicleMake: '',
        VehicleModel: '',
        VehicleColour: '',
        VehicleRegistration: '',
        NewAddress: '',
        Lat: 0,
        Lng: 0,
        Fitment: {},
        FrontViewImage: undefined,
        WindscreenImage: undefined,
        LicenceDisc: undefined,
        LicenceDiscScanned: false,
      },
      setLocation: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.SendLocation = this.SendLocation.bind(this);
    this.savePhoto = this.savePhoto.bind(this);
  }

  componentDidMount() {
    $('#welcomeModal').addClass('in').css('display', 'block');
    $('#footer').addClass('in').css('display', 'block');

    Database.FetchAllData()
      .then((data) => {
        this.setState({
          value: {
            ...this.state.value,
            VehicleMake: data.Vehicle.Make.includes('AUTOMATION') ? '' : data.Vehicle.Make,
            VehicleModel: data.Vehicle.Range.includes('AUTOMATION') ? '' : data.Vehicle.Range,
            VehicleRegistration: data.Vehicle.RegNo ?? '',
            NewAddress: data.Fitment.Address,
            Lat: Number(data.Fitment.Latitude),
            Lng: Number(data.Fitment.Longetude),
            FrontViewImage: data.Vehicle.FrontViewImage,
            WindscreenImage: data.Vehicle.WindscreenImage,
            LicenceDisc: data.Vehicle.LicenceDisc,
            LicenceDiscScanned: data.Vehicle.LicenceDiscScanned,
          },
        });
      });
  }

  handleChange(event) {
    const { value } = this.state;
    value[event.target.name] = event.target.value;
    this.setState({ value });
  }

  async handleSubmit(event) {
    event.preventDefault();
    try {
      const success = [];
      success.push(FitmentLogic.UpdateLocation(
        this.state.value.NewAddress,
        this.state.value.Lat,
        this.state.value.Lng,
      ));
      success.push(FitmentLogic.UpdateFitmentAddress(this.state.value.NewAddress));

      if (!success[0] || !success[1]) {
        throw new Error('Unable to update fitment location.');
      }

      await axios.post(`${global.BASE_URL}CustomerApp/AdditionalInfo`, this.state.value);

      await Swal.fire({
        title: 'Information Submitted Successfully',
        text: 'Thank you for submitting your information. We will confirm your selected fitment date via SMS soon based on the availability of the glass. Kindly wait for the SMS confirmation.',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      window.location.replace('http://www.autoboys.co.za');
    } catch (error) {
      await Swal.fire({
        title: 'Submission Failed',
        text: 'Please ensure you have a stable internet connection, and contact your service consultant if the issue persists.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  }

  async savePhoto(image, imageName) {
    // Map the ImageName prop values to the correct state keys
    let stateKey = imageName;
    if (imageName === 'FrontView') stateKey = 'FrontViewImage';
    if (imageName === 'Damage') stateKey = 'WindscreenImage';

    // Optimistic update — show the image immediately while the server saves in the background
    this.setState((prevState) => {
      const newValue = { ...prevState.value, [stateKey]: image };

      if (newValue.FrontViewImage && newValue.WindscreenImage && newValue.LicenceDisc) {
        toastr.success('All Vehicle Photos successfully updated', 'Complete');
      }

      return { value: newValue };
    });

    if (imageName === 'LicenceDisc') {
      const scanResults = document.getElementById('ScanResults');
      if (scanResults) scanResults.textContent = '';
    }

    try {
      const success = await VehicleLogic.saveVehicleImage(image, imageName);
      toastr.success(success.message || 'Photo successfully updated', 'Success');

      // Only re-fetch from the server for LicenceDisc because the backend
      // runs an OCR scan and we need the updated LicenceDiscScanned flag
      if (success && imageName === 'LicenceDisc') {
        const vehicle = await ClaimLogic.FetchVehicleInformation();

        this.setState((prevState) => ({
          value: {
            ...prevState.value,
            // Only update this single property from the server
            LicenceDiscScanned: vehicle.LicenceDiscScanned,
          },
        }));
      }
    } catch (error) {
      toastr.error(error.message, 'Failed to Upload Photo');
    }
  }

  async SendLocation(newAddress, Lat, Lng) {
    try {
      this.setState({
        value: {
          ...this.state.value, NewAddress: newAddress, Lat, Lng,
        },
        setLocation: true,
      });
    } catch (error) {
      toastr.error(error.message, 'Failed to update fitment location.');
    }
  }

  redirectToAutoboys() {
    $('#welcomeModal').addClass('in').css('display', 'none');
    window.location.replace('http://www.autoboys.co.za');
  }

  render() {
    const { value, setLocation } = this.state;

    const ScanMessage = value.LicenceDiscScanned ? (
      <span id="ScanResults" className="confirmed">
        Licence Disc Scanned Successfully.
        The results can be viewed in the Vehicle Details or the Activity Log
      </span>
    ) : (
      <span id="ScanResults" className="not-confirmed" />
    );

    return (
      <div>
        {/* Modal Popup */}
        <div className="modal fade" id="welcomeModal" style={{ marginTop: '100px' }}>
          <div className="modal-dialog modal-confirm">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Welcome to Autoboys Ejourney</h4>
              </div>
              <div className="modal-body">
                Please follow the prompt on the screen to confirm your vehicle details and fitment information.
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => this.redirectToAutoboys()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => $('#welcomeModal').addClass('in').css('display', 'none')}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Vehicle Photos */}
        <div className="row grey-cell">
          <div
            className="header panel-group"
            style={{ fontSize: '15px' }}
            type="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapse"
          >
            Vehicle & Licence Disc Photos (Step-1)
          </div>
          <div className="col-xs-12 panel-collapse collapse in" id="collapse">
            <div className="row text-center" style={{ marginTop: '10px' }}>
              <TakePhotoButton
                Image={value.FrontViewImage}
                ImageTitle="Front view of vehicle"
                ImageName="FrontView"
                Action={this.savePhoto}
              />
              <TakePhotoButton
                Image={value.WindscreenImage}
                ImageTitle="Damages of glass"
                ImageName="Damage"
                Action={this.savePhoto}
              />
            </div>
            <div className="row text-center" style={{ marginTop: '10px' }}>
              <TakePhotoButton
                Image={value.LicenceDisc}
                ImageTitle="Licence Disc"
                ImageName="LicenceDisc"
                Action={this.savePhoto}
              />
            </div>
            <div className="scan-messsage">{ScanMessage}</div>
          </div>
        </div>

        {/* Fitment Location */}
        <div className="row grey-cell">
          <div
            className="header panel-group"
            style={{ fontSize: '15px' }}
            type="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseOne"
          >
            Set Fitment Location (Step-2)
          </div>
          <div className="col-xs-12">
            <CurrentLocationModal SendLocation={this.SendLocation} />
            <div className="panel-collapse collapse">
              <button
                className="newBtn2 btn-success col-xs-12"
                data-toggle="modal"
                data-target="#currentLocationModal"
                type="button"
              >
                Set Fitment Location
              </button>
            </div>
          </div>
        </div>

        {/* Fitment Options */}
        {value.Lat && value.Lng ? (
          <div className="row grey-cell" id="fitmentOptions">
            <div
              className="header panel-group"
              style={{ fontSize: '15px' }}
              type="button"
              data-toggle="collapse"
              data-parent="#accordion"
              href="#collapseTwo"
            >
              Possible Fitment Options (Step-3)
            </div>
            <div className="col-xs-12">
              <div className={setLocation ? 'panel-collapse collapse in' : 'panel-collapse collapse'} id="collapseTwo">
                {setLocation ? (
                  <FitmentOptions
                    className="newBtn2 btn-success col-xs-12"
                    Lat={value.Lat}
                    Lng={value.Lng}
                    Fitment={value.Fitment ?? {}}
                    selectChoice={(f) => this.setState({ value: { ...value, Fitment: f } })}
                  />
                ) : (
                  <div className="location-error">Please set location</div>
                )}
              </div>
            </div>
          </div>
        ) : null}

        {/* Verify Information */}
        <div className="row grey-cell">
          <div
            className="header panel-group"
            style={{ fontSize: '15px' }}
            type="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseThree"
          >
            Verify the Information (Step-4)
          </div>
          <div className="col-xs-12 text-center">
            <div className="panel-collapse collapse" id="collapseThree">
              <button
                className="newBtn2 btn-success col-xs-12"
                type="submit"
                onClick={this.handleSubmit}
              >
                Information is Correct (Verify)
              </button>
              <CurrentLocationModal SendLocation={this.SendLocation} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdditionalInfo;
